module.exports = "/packs/media/images/brands/troweprice-52838159397c3d6c24d2881f14dd85db.png";